import { StateCreator } from "zustand";

// --- State Type ---
export type DialogSliceState = {
  activeDialog: string | null;
  dialogProps: Record<string, unknown> | undefined;
};

// --- Actions Type ---
export type DialogSliceActions = {
  openDialog: (dialog: string, props?: Record<string, unknown>) => void;
  closeDialog: () => void;
};

// --- Combined Type ---
export type DialogSlice = DialogSliceState & DialogSliceActions;

// --- Initial State ---
export const initialDialogState: DialogSliceState = {
  activeDialog: null,
  dialogProps: undefined,
};

// --- Slice Creator ---
export const createDialogSlice: StateCreator<
  DialogSlice,
  [],
  [],
  DialogSlice
> = (set) => ({
  ...initialDialogState,

  openDialog: (dialog, props) =>
    set({
      activeDialog: dialog,
      dialogProps: props,
    }),

  closeDialog: () =>
    set({
      activeDialog: null,
      dialogProps: undefined,
    }),
});

// --- Selectors ---
export const dialog = {
  state: (s: DialogSlice) => ({
    activeDialog: s.activeDialog,
    dialogProps: s.dialogProps,
    openDialog: s.openDialog,
    closeDialog: s.closeDialog,
  }),
};

